export function withReturnContext(href: string, pageId?: string | null): string {
  if (!href || typeof window === "undefined") {
    return href;
  }

  const params = new URLSearchParams(window.location.search);
  const resolvedPageId =
    pageId?.trim() ||
    params.get("page-id") ||
    params.get("page_id") ||
    params.get("document") ||
    params.get("documentId") ||
    params.get("doc") ||
    "";

  const url = new URL(href, window.location.origin);
  if (resolvedPageId) {
    url.searchParams.set("return_to", resolvedPageId);
  } else {
    url.searchParams.delete("return_to");
  }
  url.searchParams.delete("page_id");
  return `${url.pathname}${url.search}${url.hash}`;
}
